'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _campaignModalTemplate = require('./campaignModalTemplate.html');

var _campaignModalTemplate2 = _interopRequireDefault(_campaignModalTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var campaignModal = {

    bindings: {
        label: '@',
        campaigns: '=',
        selectedCampaignIds: '=',
        objectId: '=',
        isCustomerContact: '=',
        assignTo: '@',
        controlType: '@',
        onChildSelected: '&',
        onCampaignSelected: '=',
        closeModal: '=?'
    },

    template: ' <button type="button" ng-click="$ctrl.openModal();" class="button button-picton-blue button-clear button-small"\n                    ng-if="$ctrl.controlType==\'round-button\'">\n                        <i class="ion-ios-plus-outline"></i>\n                    </button>\n                    <button type="button" ng-click="$ctrl.openModal();" class="campaign-action-item button button-picton-blue button-outline button-font icon-right ion-plus"\n                        ng-if="$ctrl.controlType!=\'round-button\'">\n                        <span> {{ $ctrl.label | translate }}</span>\n                      \n                    </button>\n                    ',

    controller: function controller($state, $scope, $ionicModal, $ionicLoading, ApiCampaigns) {
        var _this = this;

        this.$state = $state;
        this.ApiCampaigns = ApiCampaigns;

        var objectId = this.objectId;

        // only required for contacts (to add the query parameter)
        var customer = {
            'isCustomerContact': this.isCustomerContact
        };

        this.modal = $ionicModal.fromTemplate(_campaignModalTemplate2.default, {
            scope: $scope
        });

        this.$onInit = function () {
            _this.label = _this.label || 'ASSIGN_TO_MOTHER_CAMPAIGN';
        };

        this.openModal = function () {
            _this.modal.show();
            if (_this.hasPreselectedCampaigns()) {
                _this.checkPreselectedCampaigns();
            }
        };

        this.closeModal = function () {
            _this.modal.hide();
        };

        this.createFirstCampaign = function () {
            _this.$state.go('campaignAdd', {}, {
                reload: true
            });
            _this.modal.hide();
        };

        this.hasPreselectedCampaigns = function () {
            return !!_this.selectedCampaignIds && Array.isArray(_this.selectedCampaignIds);
        };

        this.checkPreselectedCampaigns = function () {
            var self = _this;
            _this.campaigns.forEach(function (c) {
                c.checked = self.selectedCampaignIds.some(function (id) {
                    return c.campaignId == id;
                });
            });
        };

        this.selectCampaign = function (selectedCampaign) {
            if (_this.selectedCampaignIds && _this.selectedCampaignIds.includes(selectedCampaign.campaignId)) {
                selectedCampaign.checked = true;
            }
        };

        this.assignment = function () {
            var self = _this;
            var campaigns = _this.campaigns;
            var selectedIds = [];
            var selectedCampaigns = [];
            for (var i = 0; i < campaigns.length; i++) {
                if (!!campaigns[i].checked) {
                    var campaignId = campaigns[i].campaignId;
                    selectedIds.push({
                        'campaignId': campaignId
                    });
                    selectedCampaigns.push(campaigns[i].campaignTitle);
                    if (!self.selectedCampaignIds.includes(campaignId)) {
                        self.selectedCampaignIds.push(campaignId);
                    }
                }
            }
            console.log("> selected items : ", self.selectedCampaignIds);
            switch (_this.assignTo) {
                case 'contacts':
                    _this.ApiCampaigns.updateCampaignContacts(objectId, customer, selectedIds).then(function (response) {
                        console.log("> response", response, customer, objectId, selectedIds);
                        _this.onCampaignSelected();
                        _this.modal.hide();
                        $ionicLoading.hide();
                    });
                    break;
                case 'investors':
                    _this.ApiCampaigns.updateCampaignInvestors(objectId, selectedIds).then(function (response) {
                        _this.modal.hide();
                        $ionicLoading.hide();
                    });
                    break;
                case 'selections':
                    _this.ApiCampaigns.updateCampaignSelections(objectId, selectedIds).then(function (response) {
                        _this.modal.hide();
                        $ionicLoading.hide();
                    });
                    break;
                case 'campaign':
                    selectedIds = selectedIds.map(function (id) {
                        return id.campaignId;
                    });
                    self.ApiCampaigns.addChildren(self.objectId, selectedIds).then(function (response) {
                        self.onChildSelected();
                        _this.modal.hide();
                        $ionicLoading.hide();
                    });
                default:
                    return false;
            }
        };
    }
};

exports.default = campaignModal;


/** WEBPACK FOOTER **
 ** ./src/app/directives/campaignModal/campaignModal.js
 **/